import { createContext } from "react";
const DetailsPageContext = createContext({});

export default DetailsPageContext;
